<script setup>
import { ref, computed, onMounted } from 'vue';
import { useWidgets } from '@store/widgets';
import { useRoute } from 'vue-router';
import { Spin } from '@components'
import defaultWidget from '@store/defaultWidget';
import { useTranslation } from '../../composables/useTranslation';

const { t } = useTranslation();


import Header from './Header.vue';
import EditWhatsApp from './WhatsApp.vue'
import EditTriggers from './Triggers.vue'
import EditCustomize from './Customize.vue'
import EditGreetings from './Greetings.vue'
import Preview from './Preview.vue';

const $widget = useWidgets();

const templates = {
    whatsapp: EditWhatsApp,
    triggers: EditTriggers,
    customize: EditCustomize,
    greetings: EditGreetings,
}
const Template = computed( () => {
    return templates[$widget.currentTab.path]
})

const isLoading = ref(false)

onMounted( async () => {

    const widgetId = useRoute().params.widgetId || 'new';

    if ( widgetId !== 'new' ) {
        
        isLoading.value = true

        if ( $widget.widgets.length == 0 ) {
            await $widget.fetchWidgets()
        }

        const requestedWidget = $widget.widgets.find( widget => widget.id == widgetId )

        if ( requestedWidget == undefined ) {
            $widget.setCurrentWidget( defaultWidget )
        } else {
            $widget.setCurrentWidget( JSON.parse(JSON.stringify(requestedWidget)) )
        }

        isLoading.value = false
    } else {
        $widget.setCurrentWidget( defaultWidget )
    }
}) 

</script>
<template>
    <div class="w-full h-full flex flex-col gap-5">
        <Header v-if="!isLoading || isNew" />
        <div v-if="!isLoading || isNew" class="flex item justify-between h-full w-full flex-col sm:flex-row gap-5 xl:gap-10">
            <div class="w-full sm:max-w-2xl"><component :is="Template"></component></div>
            <Preview />
        </div>

        <transition name="fade">
            <div class="absolute top-0 left-0 w-full h-full flex items-center justify-center z-50" v-if="isLoading && !isNew">
                <div class="absolute top-0 left-0 w-full h-full z-0 bg-white opacity-90"></div>
                <div class="flex items-center justify-center gap-3 text-base z-50"><Spin class="text-indigo-500 w-5 h-5" /> {{ t('loading_widget') }} </div>
            </div>
        </transition>
    </div>
</template>
